module.exports = __webpack_public_path__ + "static/tpp-icon-drone-665666b1f3f0aabd2d2d803f96693a9b.png";